(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldButton', fbFieldButtonDirective);

    function fbFieldButtonDirective() {
        return {
            restrict: "EA",
            scope: {
                element:'=',
                model:'=',
                myClass: "@"
                //type: '@'
            },
            controller:fbFieldButtonDirectiveCtrl,
            bindToController: true,
            controllerAs: 'vm'
        };
    }

    function fbFieldButtonDirectiveCtrl($scope, $element, ButtonRegistry, lodash, $compile, FormBuilderService, GaService) {
        var vm = this;
        var cloneElement = null;
        this.$onInit = function() {
            vm.element.loading = false;
            vm.element.angular_id = $scope.$id;
            ButtonRegistry.set(vm.element);

            vm.click = click;

            vm.spinnerColor = '';

            setDefaultSpinnerColor();

            var template =
                '<button ladda="vm.element.loading" type="' + getType() + '" ng-click="vm.click($event)" name="' + vm.element.name + '" class="button ladda-button ' + [vm.myClass, getClass()].join(' ') +
                '" ng-disabled="vm.element.attr.disabled || vm.pageData.fbData.settings.view_only" ' +
                vm.spinnerColor + '>' +
                '<text class="div-table"><text class="div-cell">' +
                '<i class="fa ' + getIconClass() + '"></i></text>' +
                '<text class="div-cell">' +
                getLabel() + '</text></text>' +
                '</button>';

            $element.html(angular.copy(template));
            cloneElement = $compile($element.contents())($scope);

            $scope.$on('$destroy', onDestroy);
        }

        function click($event) {
            if  (lodash.get(vm.pageData, 'fbData.settings.view_only', false)) {
                return;
            }
            if (lodash.get(vm.element, 'attr.loading', true) === true) {
                //vm.element.loading = true;
                ButtonRegistry.setLoading(vm.element.name);
            }
            var eventData = {
                targetScope: vm.element,
                target: $element,
                event: $event,
            };

            if (!!vm.model) {
                eventData.model = vm.model;
            }

            if (lodash.has($scope, '$parent.vm.formIdentifier')) {
                vm.formIdentifier = $scope.$parent.vm.formIdentifier;
                var fbService = FormBuilderService.get(vm.formIdentifier);
                lodash.set(eventData, 'model', fbService.model || {});
                lodash.set(eventData, 'formIdentifier', vm.formIdentifier);
            }

            // switch (vm.element.type) {
            //     case "back":
            //         if (lodash.has(vm, 'element.event.click')) {
            //             $scope.$emit(vm.element.event.click, eventData);
            //         } else {
            //             $scope.$emit('action.common.button.back', eventData);
            //         }
            //         break;
            //     case "custom":
            //         vm.element.click();
            //         break;
            //     case "dialog-close":
            //
            //         if (lodash.has(vm, 'element.event.click')) {
            //             $scope.$emit(vm.element.event.click, eventData);
            //         } else {
            //             $scope.$emit('action.common.dialog.close', eventData);
            //         }
            //         break;
            //     case "submit":
            //         break;
            //     default:
            if (lodash.has(vm, 'element.event.click')) {
                $scope.$emit(vm.element.event.click, eventData);
            }
            //         break;
            // }
        }
        
        function getType() {
            var buttonType = (lodash.get(vm,'element.type','button'));
            if (buttonType == 'submit' || buttonType == 'reset') return buttonType; // button type = submit or button type = reset
            return "button"; // otherwise, button type = button
        }

        function getClass() {
            var classnames = [lodash.get(vm, 'element.class', '')];
            if (vm.element.label.length > 0) {
                classnames.push('has-text')
            }
            return classnames.join(' ');
        }

        function getIconClass() {
            const iconClass = lodash.get(vm, 'element.icon', '');
            if (iconClass.length === 0) {
                return 'no-icon-class';
            }
            return appendFa(iconClass);
        }

        function appendFa(className) {
            if (className.indexOf('fa-') === 0) return className;
            return 'fa-' + className;
        }

        function getLabel() {
            return lodash.get(vm.element, 'attr.fixed_label', vm.element.label);
        }

        function onDestroy() {
            cloneElement.off();
            ButtonRegistry.remove($scope.$id);
        }

        function setDefaultSpinnerColor() {
            if (getClass().indexOf('default') >= 0) {
                vm.spinnerColor = 'data-spinner-color="#888888"';
            }
        }
    }
})();